import { Select } from "antd";
import React, { useContext } from "react";
import { TimeTrackingUserDataContext } from "../../../TimeTrackingUserDataProvider";
import { TrackerContext } from "../utils/types";

const ROW_HEIGHT = 46;

export const ProjectSelect: React.FC = () => {
  const { formData, setFormData, isTracking } = useContext(TrackerContext);
  const { projects } = useContext(TimeTrackingUserDataContext);

  const selectedProject = projects.find(
    (p) => p.projectId === formData.projectId,
  );

  if (isTracking) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: "0 12px",
          borderRight: "1px solid #d9d9d9",
          height: ROW_HEIGHT,
          whiteSpace: "nowrap",
          fontWeight: 600,
          fontSize: 13,
          color: selectedProject?.color || "#137AE9",
        }}
      >
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: selectedProject?.color || "#137AE9",
            display: "inline-block",
          }}
        />
        {selectedProject?.projectName || "Project"}
      </div>
    );
  }

  return (
    <div style={{ borderRight: "1px solid #d9d9d9", padding: "0 12px" }}>
      <Select
        style={{
          width: 200,
        }}
        value={formData.projectId || undefined}
        placeholder="+ Project"
        onChange={(value) =>
          setFormData((prev) => ({ ...prev, projectId: value }))
        }
        dropdownMatchSelectWidth={false}
        optionLabelProp="label"
      >
        {projects.map((p) => (
          <Select.Option
            key={p.projectId}
            value={p.projectId}
            label={
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  lineHeight: `${ROW_HEIGHT}px`,
                  height: "100%",
                }}
              >
                <span
                  style={{
                    width: 11,
                    height: 11,
                    borderRadius: "50%",
                    backgroundColor: p.color,
                    display: "inline-block",
                    flexShrink: 0,
                  }}
                />
                {p.projectName}
              </span>
            }
          >
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span
                style={{
                  width: 11,
                  height: 11,
                  borderRadius: "50%",
                  backgroundColor: p.color,
                  display: "inline-block",
                  flexShrink: 0,
                }}
              />
              {p.projectName}
            </span>
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};
